module.exports = __webpack_public_path__ + "static/media/92.debe8489.jpg";